// ShimmerMainContainer.jsx
const ShimmerMainContainer = () => {
	return (
		<div className="main-container-shimmer bg-gradient-to-r from-black relative w-screen aspect-video animate-pulse">
			<div className="absolute z-[1] text-white w-full h-full flex flex-col gap-4 justify-center pt-[15%] md:pt-0 pl-4 md:pl-8">
				<div className="bg-gray-700 h-12 w-1/2 md:w-1/3 rounded-md"></div>
				<div className="flex gap-4 md:mt-4">
					<div className="h-8 md:h-10 w-24 bg-gray-600 rounded-md"></div>
					<div className="h-8 md:h-10 w-32 bg-gray-600 rounded-md"></div>
				</div>
			</div>
		</div>
	);
};

export default ShimmerMainContainer;
